module.exports = __webpack_public_path__ + "img/0Q3B8222_Foamcore_MockedUp.f4044659.jpg";